import { combineReducers } from 'redux';

import Auth from './Auth';
import User from './User';
import Navigation from './Navigation';
import Layout from './Layout';
import Organization from './Organization';
import Event from './Event';
import Toastr from './Toastr';
import PartnerPortalSettings from './PartnerPortalSettings';
import CartReducer from './CartReducer';
import ShopReducer from './ShopReducer';
import OrdersReducer from './OrdersReducer';
import OrderReducer from './OrderReducer';
import Partner from './Partner';
import Notifications from './Notifications';

const reducer =
  combineReducers({
    auth: Auth,
    user: User,
    layout: Layout,
    navigation: Navigation,
    organization: Organization,
    event: Event,
    cart: CartReducer,
    shop: ShopReducer,
    orders: OrdersReducer,
    order: OrderReducer,
    toastr: Toastr,
    partnerPortalSettings: PartnerPortalSettings,
    partner: Partner,
    notifications: Notifications
  });

export default reducer;
